import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UserInfoService  } from '../../../BaseFramework/core/http/user-info.service';
import { OrgDataService } from './org-data.service';
import { CommonUtilty } from '../../../BaseFramework/core/utilities/commonUtility';
import { AppMetadataHandler } from 'app/BaseFramework/configs/app-metadata.handler';
import { TechnicalTranslatePipe } from 'app/BaseFramework/shared/custom-pipes';
import { environment } from 'environments/environment';
import { LookupDataService } from 'app/BaseFramework/core/http/lookupdata.service';
import { OrgChart } from 'd3-org-chart';

import { AppOrganizationSettings } from 'app/BaseFramework';
interface Employee {
  userId: string;
  name: string;
  designation: string;
  gender: string | null; // Adjust type as needed
  totPendingCase: number;
  subordinates: Employee[];
  img : string;
}

interface Person {
  designation: string;
  gender: string;
  image: string;
  img: string;
  name:string;
  subordinates: Person [];
  totPendingCase:number;
  userId: string;
}

interface FlatPerson {
  id: string;
  parentId: string | null;
  name: string;
  title: string;
  img: string;
  totPendingCase:number;
}
@Component({
  selector: 'app-org-hierarchy',
  templateUrl: './org-hierarchy.component.html',
  styleUrls: ['./org-hierarchy.component.scss'],
  providers: [TechnicalTranslatePipe]
})
export class OrgHierarchyComponent implements OnInit {
  // @ViewChild('chartContainer') chartContainer!: ElementRef;
  @ViewChild('chartuserContainer') chartuserContainer!: ElementRef;
  @ViewChild('chartOrgContainer') chartOrgContainer!: ElementRef;
  chartUser: any;
  chartOrg: any;

  constructor(
    public userInfoService: UserInfoService,
    public OrgDataService:OrgDataService,
    public commonUtility: CommonUtilty,
    public appMetadataHandler: AppMetadataHandler,
    public technicalTranslatePipe: TechnicalTranslatePipe,
    public lookupDataService : LookupDataService,
    public appOrganizationSettings: AppOrganizationSettings
  ) { }

  currentUserID:string = null;
  fetchUserHierarchyDataLevel = this.appMetadataHandler.fetchTillUserHierarchyDataLevel;
  selectedHierarchy: string;

  ngOnInit() {
    this.selectedHierarchy = "USER";
    this.getCompanyDetails();
    if(this.userInfoService.getUserId() != "no-user"){
      this.currentUserID = this.userInfoService.getUserId();
    }
    this.changeUserHierarchy();
    // Code to convert existing data structure into new structure used for d3-org-chart
    // const flatJsonData = convertToFlatJson(jsonData);
    // console.log(flatJsonData);
  }

  ngAfterViewInit() {
    // Sample data
    const data = [
      { id: "1", parentId: "", name: "Metamorphosys", title: "Company", img: "/assets/images/ico/company.png"},
      { id: "2", parentId: "1", name: "Matthew Wikes", title: "Regional Director", img: "/assets/images/ico/male.png" },
      { id: "3", parentId: "1", name: "Tina Landry", title: "Sales Manager", img: "/assets/images/ico/female.png" },
      { id: "4", parentId: "2", name: this.userInfoService.getUserName() != "no-user" ? this.userInfoService.getUserName() + ' (YOU)'  : 'You', title: "Senior Underwriter", img: "/assets/images/ico/male.png" },
      { id: "5", parentId: "4", name: "Dylan Wilson", title: "Underwriter", img: "/assets/images/ico/other.png" },
      { id: "6", parentId: "4", name: "Deb Curtis", title: "Data entry operator", img: "/assets/images/ico/female.png" },
      { id: "7", parentId: "4", name: "Wilson Davis", title: "Manager", img: "/assets/images/ico/male.png" },
    ];

    this.chartUser = new OrgChart()
      .container(this.chartuserContainer.nativeElement)
      .data(data)
      .nodeWidth((d: any) => 260)
      .nodeHeight((d: any) => 100)
      .childrenMargin((d: any) => 50)
      .compactMarginBetween((d: any) => 15)
      .compactMarginPair((d: any) => 80)
      .nodeContent((d: any) => {
      //   return `
      //     <div style="padding-top:30px;background-color:none;margin-left:1px;height:${d.height
      //     }px;border-radius:2px;overflow:visible">
      //         <div style="height:${d.height - 32
      //     }px;padding-top:0px;background-color:white;border:1px solid lightgray;">

      //           <img src=" ${d.data.img
      //     }" style="margin-top:-30px;margin-left:${d.width / 2 - 30}px;border-radius:100px;width:60px;height:60px;" />

      //          <div style="margin-right:10px;margin-top:15px;float:right">${d.data.id
      //     }</div>
               
      //          <div style="margin-top:-30px;background-color:#3AB6E3;height:10px;width:${d.width - 2
      //     }px;border-radius:1px"></div>

      //          <div style="padding:10px; padding-top:35px;text-align:center">
      //              <div style="color:#111672;font-size:16px;font-weight:bold"> ${d.data.name
      //     } </div>
      //              <div style="color:#404040;font-size:16px;margin-top:4px"> ${d.data.title
      //     } </div>
      //          </div> 
      //          <div style="display:flex;justify-content:space-between;padding-left:15px;padding-right:15px;">
      //            <div > Manages:  ${d.data._directSubordinates} 👤</div>  
      //            <div > Oversees: ${d.data._totalSubordinates} 👤</div>    
      //          </div>
      //         </div>     
      // </div>
      //   `;
      return `
      <div style="display: flex;
    background: white;
    border-radius: 8px;
    box-shadow: rgb(37 116 186 / 65%) 0px 0px 16px;
    overflow: hidden;
    width: 260px;
    height: 100px;
    text-align: left;">
        <img src="/assets/images/ico/female.png" alt="User Image" style="
    width: 60px;
    height: 60px;
    margin-top: 20px;
    margin-left: 5px;
    border-radius: 100%;
    box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px;
">
        <div style="
    padding: 10px;
">
            <h2 style="margin: 0 0 2px;
    color: #4f7fa9;
    font-size: 16px;
    font-weight: 600;">${d.data.name}</h2>
            <h3 style="margin-top: 0;
    color: rgb(90 142 182 / 85%);
    font-size: 14px;">${d.data.title}</h2>
            <div style="display:flex;justify-content:space-between;">
                 <p style="
    color: #666; margin-bottom: 2px;"> Manages: ${d.data._directSubordinates} 👤</p>  
                <p style="
    color: #666; margin-bottom: 2px;"> Oversees: ${d.data._totalSubordinates} 👤</p>    
               </div>
            <p style="margin-top: 2px;
    color: #666;">Assigned cases: ${d.data.totPendingCase} </p>
        </div>
    </div>
      `
    });
      this.chartOrg = new OrgChart()
      .container(this.chartOrgContainer.nativeElement)
      .data(data)
      .nodeWidth((d: any) => 270)
      .nodeHeight((d: any) => 100)
      .childrenMargin((d: any) => 50)
      .compactMarginBetween((d: any) => 15)
      .compactMarginPair((d: any) => 80)
      .nodeContent((d: any) => {
      //   return `
      //     <div style="padding-top:30px;background-color:none;margin-left:1px;height:${d.height
      //     }px;border-radius:2px;overflow:visible">
      //         <div style="height:${d.height - 32
      //     }px;padding-top:0px;background-color:white;border:1px solid lightgray;">

      //           <img src=" ${d.data.img
      //     }" style="margin-top:-30px;margin-left:${d.width / 2 - 30}px;border-radius:100px;width:60px;height:60px;" />

      //          <div style="margin-right:10px;margin-top:15px;float:right">${d.data.id
      //     }</div>
               
      //          <div style="margin-top:-30px;background-color:#3AB6E3;height:10px;width:${d.width - 2
      //     }px;border-radius:1px"></div>

      //          <div style="padding:10px; padding-top:35px;text-align:center">
      //              <div style="color:#111672;font-size:16px;font-weight:bold"> ${d.data.name
      //     } </div>
      //              <div style="color:#404040;font-size:16px;margin-top:4px"> ${d.data.title
      //     } </div>
      //          </div> 
      //          <div style="display:flex;justify-content:space-between;padding-left:15px;padding-right:15px;">
      //            <div > Manages:  ${d.data._directSubordinates} 👤</div>  
      //            <div > Oversees: ${d.data._totalSubordinates} 👤</div>    
      //          </div>
      //         </div>     
      // </div>
      //   `;
      return `
      <div style="display: flex;
    background: white;
    border-radius: 8px;
    box-shadow: rgb(37 116 186 / 65%) 0px 0px 16px;
    overflow: hidden;
    width: 270px;
    height: 100px;
    text-align: left;">
        <img src="/assets/images/ico/female.png" alt="User Image" style="
    width: 60px;
    height: 60px;
    margin-top: 20px;
    margin-left: 5px;
    border-radius: 100%;
    box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px;
">
        <div style="
    padding: 10px;
">
            <h2 style="margin: 0 0 2px;
    color: #4f7fa9;
    font-size: 16px;
    font-weight: 600;">${d.data.name}</h2>
            <h3 style="margin-top: 0;
    color: rgb(90 142 182 / 85%);
    font-size: 14px;">${d.data.title}</h2>
            <div style="display:flex;justify-content:space-between;">
                 <p style="
    color: #666; margin-bottom: 2px;"> Manages: ${d.data._directSubordinates} 👤</p>  
                <p style="
    color: #666; margin-bottom: 2px;"> Oversees: ${d.data._totalSubordinates} 👤</p>    
               </div>
            <p style="margin-top: 2px;
    color: #666;">Assigned cases: ${d.data.totPendingCase} </p>
        </div>
    </div>
      `
      
    });
  }
  showChart : boolean = false;
  orgHierarchyData = null;

  changeUserHierarchy(){
    if(this.commonUtility.isArrayIterable(this.userHierarchyListTillLevel)){
      this.hierarchyData = [...this.userHierarchyListTillLevel].find(e => true);
     let hierarchyDataList = [...this.userHierarchyListTillLevel].find(e => true);
     let hierarchyData = this.convertToFlatJson([...this.userHierarchyListTillLevel])
     this.chartUser.data(hierarchyData)
     this.chartUser.render()
    console.log(hierarchyData)
      this.showChart = true;
      // }
      // this.hierarchyData = this.showTotalCaseCount(this.hierarchyData)
    }else{
      this.fetchUserHierarchyWithLevel();
    }

    if(this.commonUtility.isArrayIterable(this.wholeOrgList)){
      this.orgHierarchyData = [...this.wholeOrgList].find(e => true);
      let hierarchyDataList = [...this.wholeOrgList].find(e => true);
      let orgHierarchyData= this.convertToFlatJson([...this.wholeOrgList])
      this.chartOrg.data(orgHierarchyData)
      this.chartOrg.render()
      console.log(orgHierarchyData)
      // this.orgHierarchyData = this.orgHierarchyData.map(item=> this.convertToFlatJson(item))
      this.showChart = true;
      
    }else{
      this.fetchOrgHierarchy();
    }
  }


  hierarchyData: any;
  wholeOrgList = [];
  userHierarchyList = [];
  userHierarchyListTillLevel = [];

  
  fetchOrgHierarchy(){
    this.OrgDataService.fetchWholeOrgHierarchy().subscribe(resp => {
      if(this.commonUtility.isArrayIterable(resp)){
        // this.updateHierarchyData(resp);
        resp = this.updateOrgHierarchyData(resp);
        let tempParent = {
          name : this.organizationMetaData.displayName,
          designation : "Company",
          img : "/assets/images/ico/company.png",
          subordinates: this.commonUtility.deepCopy(resp)
        }
        this.wholeOrgList = [tempParent];

        this.changeUserHierarchy();
      }else if(environment['demo']){
        this.wholeOrgList = this.commonUtility.deepCopy(this.dummyOrgData);
        this.changeUserHierarchy();
      }
    },
    error =>{
      console.log("Issue in fetching Organization hierarchy data", error);
    });
  }
  organizationMetaData
  getCompanyDetails(){
    this.organizationMetaData = this.appOrganizationSettings.getOrganizationMetaData();
  }
  fetchUserHierarchy(){
    this.OrgDataService.fetchUserHierarchy(this.currentUserID).subscribe(resp => {
      if(this.commonUtility.isArrayIterable(resp)){
        this.updateHierarchyData(resp);
        this.userHierarchyList = this.commonUtility.deepCopy(resp);
        this.changeUserHierarchy();
      }
    },
    error =>{
      console.log("Issue in fetching User hierarchy data", error);
    });
  }

  fetchUserHierarchyWithLevel(){
    this.OrgDataService.fetchUserHierarchyTillLevel(this.currentUserID).subscribe(resp => {
      if(this.commonUtility.isArrayIterable(resp)){
        this.updateHierarchyData(resp);
        this.userHierarchyListTillLevel = this.commonUtility.deepCopy(resp);
        // this.userHierarchyListTillLevel = this.convertToLookupKey(this.userHierarchyListTillLevel);
        this.changeUserHierarchy();
      }else if(environment['demo']){
        this.userHierarchyListTillLevel = this.commonUtility.deepCopy(this.dummyUserData);
        this.changeUserHierarchy();
      }
    },
    error =>{
      console.log("Issue in fetching User hierarchy data", error);
    });
  }

  convertToLookupKey(resp){
    if(resp && resp.designation ){
      this.lookupDataService.getLookup('userDesignationCd').subscribe(lookupData =>{
        if(lookupData){
        let lookup = lookupData.filter(item => item.lookupKey.toUpperCase() == resp.designation.toUpperCase())
        resp.designation= lookup ? lookup[0] ? lookup[0].lookupValue ? lookup[0].lookupValue : resp.designation : resp.designation : resp.designation;
        // resp.name = `${resp.name}(${resp.totPendingCase} Cases)`
        this.updateSubordinates(resp.subordinates, lookupData);

        return resp;
      }
      return resp;
      })
    }
    return resp;
  }

  updateSubordinates(subordinates, lookupData) {
    if (subordinates && this.commonUtility.isArrayIterable(subordinates)) {
      subordinates.forEach(subUser => {
        let subLookup = lookupData.find(item => item.lookupKey.toUpperCase() == subUser.designation.toUpperCase());
        subUser.designation = subLookup ? (subLookup.lookupValue || subUser.designation) : subUser.designation;
        // subUser.name = `${subUser.name}(${subUser.totPendingCase} cases)`;
  
        this.updateSubordinates(subUser.subordinates, lookupData);
      });
    }
  }
  


  updateHierarchyData(resp){
    resp.forEach(element => {
      // if(element.genderCd == 'M'){
      //   element.img = "/assets/images/ico/employee.png";
      // }
      // else if(element.genderCd == 'F '){
      //   element.img = "/assets/images/ico/employee.png";
      // }
      // else{
        element.img = "/assets/images/ico/employee.png";
      // }

      // element.designation = element.designation ? this.technicalTranslatePipe.transform(element.designation) : element.designation;
      // element.name = `${element.name} (${element.totPendingCase ? element.totPendingCase : 0 } cases)`
      if(this.commonUtility.isArrayIterable(element.subordinates)){
        this.updateHierarchyData(element.subordinates);
      }
    });
  }
  orgDetails = [];
  updateOrgHierarchyData_old(resp){
    resp.forEach(element => {
      // if(element.genderCd == 'M'){
      //   element.img = "/assets/images/user.png";
      // }
      // else if(element.genderCd == 'F '){
      //   element.img = "/assets/images/user.png";
      // }
      // else{
      //   element.img = "/assets/images/user.png";
      // }
      // element.img = "/assets/images/ico/employee.png";
      let details ={
      "userId": element.userId,
      "name": element.name,
      "designation": element.designation,
      "gender": element.gender,
      "totPendingCase": element.totPendingCase,
      "subordinates": element.subordinates
      }
      // element.designation = element.designation ? this.technicalTranslatePipe.transform(element.designation) : element.designation;
      // details.name = `${details.name} (${details.totPendingCase ? details.totPendingCase : 0 } cases)`
      if(this.commonUtility.isArrayIterable(details.subordinates)){
        this.updateOrgHierarchyData(details.subordinates);
      }
      this.orgDetails.push(details)
    });
  }

  updateOrgHierarchyData(resp: Employee[]): Employee[] {
    return resp.map(employee => {
        const updatedEmployee: Employee = {
            userId: employee.userId,
            name: `${employee.name}`,
            img : "/assets/images/ico/employee.png",
            designation: employee.designation,
            gender: employee.gender,
            totPendingCase: employee.totPendingCase,
            subordinates: [] // Initialize subordinates array
        };
        // name: `${employee.name} (${employee.totPendingCase ? employee.totPendingCase : 0} cases)`,
        if (employee.subordinates.length > 0) {
            updatedEmployee.subordinates = this.updateOrgHierarchyData(employee.subordinates);
        }

        return updatedEmployee;
    });
}

  dummyOrgData = [{
    name: 'Metamorphosys',
    designation : "Company",
    img : "/assets/images/ico/company.png",
    subordinates: [
      {
        name: 'Matthew Wikes',
        designation: 'Regional Director',
        img: '/assets/images/ico/male.png',
        subordinates: [
          {
            name: 'Tina Landry',
            designation: 'Sales Manager',
            img: '/assets/images/ico/female.png',
            subordinates: []
          }

        ]
      },
      {
        name: this.userInfoService.getUserName() != "no-user" ? this.userInfoService.getUserName() + ' (YOU)'  : 'You',
        designation: 'Senior Underwriter',
        img: '/assets/images/ico/male.png',
        subordinates: [
          {
            name: 'Dylan Wilson',
            designation: 'Underwriter',
            img: '/assets/images/ico/other.png',
            subordinates: []
          },
          {
            name: 'Deb Curtis',
            designation: 'Data entry operator',
            img: '/assets/images/ico/female.png',
            subordinates: []
          },
          {
            name: 'Wilson Davis',
            designation: 'Underwriter',
            img: '/assets/images/ico/male.png',
            subordinates: []
          },
        ]
      },
      {
        name: 'Larry Phung',
        designation: 'Manager',
        img: '/assets/images/ico/female.png',
        subordinates: []
      }
    ]
  }];

  dummyUserData = [{
    name: 'Yugi Martin',
    designation: 'CEO',
    img: '/assets/images/ico/male.png',
    subordinates: [
      {
        name: this.userInfoService.getUserName() != "no-user" ? this.userInfoService.getUserName() + ' (YOU)'  : 'You',
        designation: 'Senior Underwriter',
        img: '/assets/images/ico/male.png',
        subordinates: [
          {
            name: 'Dylan Wilson',
            designation: 'Underwriter',
            img: '/assets/images/ico/other.png',
            subordinates: []
          },
          {
            name: 'Deb Curtis',
            designation: 'Data entry operator',
            img: '/assets/images/ico/female.png',
            subordinates: []
          },
          {
            name: 'Wilson Davis',
            designation: 'Underwriter',
            img: '/assets/images/ico/male.png',
            subordinates: []
          },
        ]
      }
    ]
  }];

  // Code to convert existing data structure into new structure used for d3-org-chart
  convertToFlatJson(data: Person[]): FlatPerson[] {
    const result: FlatPerson[] = [];
    let idCounter = 1;

    function traverse(person: Person, parentId: string | null) {
      const id = idCounter.toString();
      idCounter++;

      result.push({
        id: id,
        parentId: parentId,
        name: person.name,
        title: person.designation,
        img: person.img,
        totPendingCase: person.totPendingCase
      });

      person.subordinates.forEach(subordinate => {
        traverse(subordinate, id);
      });
    }

    data.forEach(person => traverse(person, null));
    return result;
  }

}
